"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStationaryEntityLike = exports.StationaryEntity = exports.StationaryEntityClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DeviceEnabledType_1 = require("./Device/DeviceEnabledType");
exports.StationaryEntityClassName = 'StationaryEntity';
class StationaryEntity extends DeviceEnabledType_1.DeviceEnabledType {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.StationaryEntityClassName)
            throw new Error(`Tried to create a ${exports.StationaryEntityClassName} from a ${ob.type} object!`);
        super(exports.StationaryEntityClassName, { ...ob });
        this.type = ob.type ?? exports.StationaryEntityClassName;
        this.angle = ob.angle ?? null;
        this.bearing = ob.bearing ?? null;
        this.temperature = ob.temperature ?? null;
        this.pulseCount = ob.pulseCount ?? null;
        this.score_angle = ob.score_angle ?? null;
        this.score_bearing = ob.score_bearing ?? null;
        this.score_temperature = ob.score_temperature ?? null;
        this.score_pulseCount = ob.score_pulseCount ?? null;
        this.batteryPercentage = ob.batteryPercentage ?? null;
        this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? null;
        this.rssi = ob.rssi ?? null;
        this.sf = ob.sf ?? null;
        this.snr = ob.snr ?? null;
        this.fCnt = ob.fCnt ?? null;
        this.deviceEui = ob.deviceEui ?? null;
        this.gatewayEui = ob.gatewayEui ?? null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            angle: {
                label: 'Angle',
                type: 'Number',
                editable: false,
            },
            bearing: {
                label: 'Bearing',
                type: 'Number',
                editable: false,
            },
            temperature: {
                label: 'Temperature',
                type: 'Number',
                units: '℃',
                editable: false,
            },
            pulseCount: {
                label: 'Pulse Count',
                type: 'Number',
                editable: false,
            },
        };
    }
}
exports.StationaryEntity = StationaryEntity;
const isStationaryEntityLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.StationaryEntityClassName;
};
exports.isStationaryEntityLike = isStationaryEntityLike;
